import { render, staticRenderFns } from "./pricingAnalytics.vue?vue&type=template&id=45f6f50e"
import script from "./pricingAnalytics.vue?vue&type=script&lang=js"
export * from "./pricingAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports